import Icon from "@components/ui/icon";
import { useState } from "react";
import type { IMediaFolder } from "@/shared/types";
import { MediaLibFolderActions } from "./media-lib-folder-actions";

interface IProps {
  folder: IMediaFolder;
  setSelectedFolderId: (id: string | null) => void;
  archiveFilesInFolders?: (folderIds: string[]) => void;
}

export const MediaLibFolder = ({
  folder,
  setSelectedFolderId,
  archiveFilesInFolders,
}: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <li
      className="hover:tw-shadow-hoverd-folder tw-group tw-relative tw-flex tw-cursor-pointer tw-items-center tw-space-x-2 tw-overflow-hidden tw-rounded-lg tw-border tw-border-[#E4E3E9] tw-p-3 tw-pr-5 tw-shadow-integration-folder"
      onMouseLeave={isOpen ? () => setIsOpen(false) : undefined}
      onClick={() => {
        setSelectedFolderId(folder._id);
      }}
    >
      <MediaLibFolderActions
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        folder={folder}
        archiveFilesInFolders={archiveFilesInFolders}
      />
      <Icon
        icon="ri-folder-fill"
        className="tw-text-[16px]/none tw-text-blue-500"
      />
      <div className="tw-overflow-hidden tw-text-ellipsis tw-whitespace-nowrap tw-text-[11px] tw-font-semibold tw-text-blue-700">
        {folder.title}
      </div>
    </li>
  );
};
